import React from 'react'
import Classes from '../Information.module.css'

export default function Contact({ handleNext, handleBack, formData, setFormData }) {
  const handleChange = (e) => {
    setFormData({ ...formData, contactEmail: e.target.value });
  };

  return (
    <>
      <div className={Classes.infoCon} >
        <div>
          <h3>Contact</h3>
        </div>
        <div className={Classes.infoConMiddle} >
          <div className={Classes.textInstructions} >
            <h5 className={`${Classes.textBold} mb-10`} style={{ fontSize: '13px' }} >When we submit information removal requests on your behalf, data brokers may require your email address to confirm your identity.</h5>
            <h5 className={Classes.text} > Please provide an active email address where you may receive verification emails from data brokers. </h5>
            <h5 className={Classes.text} > These emails may require you to take additional steps to complete the information removal process. </h5>
          </div>
          <div className={Classes.flexColGroup} style={{ marginTop: '2rem' }} >
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Email Address (optional)</h5>
              <input
                type='text'
                value={formData.contactEmail}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='example@mail.com'
              />
            </div>
          </div>
        </div>
        <div>
          <div className={Classes.flexEnd} >
            <div className={Classes.flexAlign10} >
              <button className={Classes.backBtn} onClick={handleBack} > <h5>Back</h5> </button>
              <button className={Classes.nextBtn} onClick={handleNext} > <h5>Next</h5> </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}